import React from "react";


function Program() {


  return (
    <section id="program" className="organization-section">
      <h2>Programa</h2>
      <div className="organization-container">
        <div className="organization-column">
          <p>09:00 - 09:45 Registo das Equipas</p>
          <p>09:45 - 10:05 Sessão de Abertura</p>
          <p>10:05 - 10:15 Explicação do Ambiente da Prova</p>
          <p>10:30 - 15:30 Prova</p>
          <p>15:30 - 16:15 Convívio</p>
          <p>16:15 - 17:30 Sessão de Encerramento</p>
        </div>
        <div className="foto-column">
              <img src="imgs/ESTGA_Auditorium.png" alt="Imagem 1" />
        </div>
      </div>
    </section>
  );
}





export default Program;
